import * as React from "react";
const SvgFiRrConstellation = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-constellation_svg__a)">
      <path
        fill="#062147"
        d="M20.75 17.5c-.641 0-1.238.186-1.742.508l-4.429-3.659a3.23 3.23 0 0 0 .422-1.599 3.255 3.255 0 0 0-2.164-3.063l.332-3.319A3.26 3.26 0 0 0 15.413 4h2.175a3.256 3.256 0 0 0 3.162 2.5A3.254 3.254 0 0 0 24 3.25 3.254 3.254 0 0 0 20.75 0a3.26 3.26 0 0 0-3 2h-2.5a3.26 3.26 0 0 0-3-2A3.254 3.254 0 0 0 9 3.25c0 1.411.904 2.615 2.164 3.063l-.332 3.319A3.26 3.26 0 0 0 8.588 12H6.343a3.26 3.26 0 0 0-3.092-2.25A3.254 3.254 0 0 0 .001 13a3.254 3.254 0 0 0 3.25 3.25c1.443 0 2.67-.946 3.092-2.25h2.408a3.26 3.26 0 0 0 3 2c.477 0 .93-.103 1.339-.289l4.643 3.835A3.254 3.254 0 0 0 20.752 24a3.254 3.254 0 0 0 3.25-3.25 3.254 3.254 0 0 0-3.25-3.25zm0-15.5c.689 0 1.25.561 1.25 1.25s-.561 1.25-1.25 1.25-1.25-.561-1.25-1.25S20.061 2 20.75 2m-8.5 0c.689 0 1.25.561 1.25 1.25s-.561 1.25-1.25 1.25S11 3.939 11 3.25 11.561 2 12.25 2m-9 12.25C2.561 14.25 2 13.689 2 13s.561-1.25 1.25-1.25S4.5 12.311 4.5 13s-.561 1.25-1.25 1.25m7.25-1.5c0-.689.561-1.25 1.25-1.25s1.25.561 1.25 1.25S12.439 14 11.75 14s-1.25-.561-1.25-1.25M20.75 22c-.689 0-1.25-.561-1.25-1.25s.561-1.25 1.25-1.25 1.25.561 1.25 1.25S21.439 22 20.75 22M6 20.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 6 20.5m18-9a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 24 11.5m-11 11a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 13 22.5M0 1.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 0 1.5m4 4a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 4 5.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-constellation_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrConstellation;
